module["exports"] = [
  "Polska"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/default_country.js
// module id = 1391
// module chunks = 1